import React, { useState, useEffect, useRef } from 'react';

import { useQuery } from '@apollo/react-hooks';
import { GET_ENDS } from './queries';
import { IEnds } from '../../../helper/Types';

import ENDsCompoent from './ENDsCompoent';


function ENDsContainer() {
    const [more, setMore] = useState(false);
    const [limit, setLimit] = useState(10);
    const loadData = useQuery<IEnds>(GET_ENDS, {
        variables: {
            offsetDate: undefined,
            limit: limit
        },
        fetchPolicy: "cache-first"
    });

    useEffect(() => {
        if( !loadData.loading && !loadData.error ) {
            const loadedData:any = loadData.data?.ends;
            setMore(loadedData.count > loadedData.posts.length);
        }
    }, [loadData]);


    return(
        <article className="layout-contents-container">

            { !loadData.error &&
                (
                    <ENDsCompoent items={loadData.data?.ends.posts || []} more={more}
                        onLoadMore={(offsetDate) => {
                            const { data, fetchMore } = loadData;
                            fetchMore({
                                variables: {
                                    offsetDate: offsetDate,
                                    limit: limit
                                },
                                updateQuery: (prev:any, { fetchMoreResult } ) => {
                                    if (!fetchMoreResult) return prev;

                                    const posts = [...prev.ends.posts, ...fetchMoreResult.ends.posts];
                                    setMore(fetchMoreResult.ends.count < posts.length)
                                    
                                    return Object.assign({} , prev, {
                                        ends: {
                                            ...prev.ends,
                                            posts: posts,
                                        }
                                    });
                                }
                            })
                        }}
                    />
                )
            }

        </article>
    );
}

export default ENDsContainer;
